import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import NavBar from "./components/NavBar";
import Login from "./scenes/Login";
import Logout from "./scenes/Logout";
import LoginAccept from "./scenes/LoginAccept";
import PrivateRoute from "./services/PrivateRoute";

import SearchResults from "./scenes/SearchResults";
import ProfilPage from "./scenes/ProfilPage";
import HomePage from "./scenes/HomePage";

import * as tokens from "./services/tokens";
import authenticatedFetch from "./services/authenticatedFetch";

export let mountedRootComponent;

export default class App extends Component {
  constructor(props) {
    super(props);

    // Load JWT token and user info from LocalStorage
    const localInfos = tokens.getLocalInfos();
    const localJwtToken = tokens.getJwtToken();
    if (localInfos && localJwtToken) {
      this.state = { userInfos: localInfos, isAuthenticated: true };
    } else {
      this.state = { userInfos: null, isAuthenticated: false };
    }
  }

  componentDidMount() {
    mountedRootComponent = this;

    // check if the token is not expired
    authenticatedFetch('tokenCheck');
  }

  showLogin() {
    localStorage.clear(); // Invalidate known token
    this.setState({ isAuthenticated: false });
  }

  render() {
    const { isAuthenticated } = this.state;

    return (
      <div className="h-100">
        <Switch>
          <Route path="/login" component={Login} />
          {!isAuthenticated && (
            <Route
              path="/loginAccept/"
              component={props => (
                <LoginAccept
                  casToken={props.location.search}
                  passUserInfos={(info) =>
                    this.setState({
                      userInfos: info,
                      isAuthenticated: true
                    })
                  }
                />
              )}
            />
          )}
          <PrivateRoute
            isAuthenticated={isAuthenticated}
            path="/logout/"
            component={Logout}
          />
          <PrivateRoute
            isAuthenticated={isAuthenticated}
            component={() => (
              <React.Fragment>
                <NavBar userInfos={this.state.userInfos} />
                <section>
                  <Switch>
                    <Redirect from="/loginAccept" to="/" />
                    <Route exact path="/" component={HomePage} />
                    <Route path="/search/:term" component={SearchResults} />
                    <Route path="/affectation/:term" component={SearchResults} />
                    <Route path="/description/:term" component={SearchResults} />
                    <Route path="/profil/:uid" component={ProfilPage} />
                  </Switch>
                </section>
              </React.Fragment>
            )}
          />
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js